<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      合同基本信息
    </div>
    <div class="rj-page-card__content">
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订单日期：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.createTime }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div v-if="info.contractType !=='服务订单'" class="rj-baseinfo__label">
              供货单位(甲方)：
            </div>
            <div v-else class="rj-baseinfo__label">
              供货单位(乙方)：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.supplyUnit }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              电子合同编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ info?.contractNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div v-if="info.contractType !=='服务订单'" class="rj-baseinfo__label">
              订货单位(乙方)：
            </div>
            <div v-else class="rj-baseinfo__label">
              订货单位(甲方)：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.orderUnit }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订货单位编码：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.orderUnitCode }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              客户合同编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.customerContractNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              供货单位地址：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.supplyAddress }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div v-if="info.contractType !=='服务订单'" class="rj-baseinfo__label">
              供货单位电话(甲方)：
            </div>
            <div v-else class="rj-baseinfo__label">
              供货单位电话(乙方)：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.supplyPhone }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              项目名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.projectName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              最终客户：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.finalCustomer }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              客户签约类型：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.customerContractType }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订单分类：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.contractType }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              币种：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.currencyName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              净销售额：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.netSales }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              现销或赊销：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.strSalesType }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              账期：
            </div>
            <div class="rj-baseinfo__item force-line-break">
              {{ info.accountPeriod }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              付款方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.paymentMethodName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订单类型：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.saleTypeName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              是否测试样机下单：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.strTestProject }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              外销姓名：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.salesManName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              部门：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.departmentName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              区域：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.regionName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              项目代码(CRM编号)：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.projectCode }}
            </div>
          </div>
        </div>

        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              售前姓名：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.preSalesName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              区域商务专员：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.regionBusinessCommissioner }}
            </div>
          </div>
        </div>

        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              首级集成商：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.integratorName || '无' }} <el-tag v-if="info.isIntegratorServiceSubject" type="danger">
                服务主体
              </el-tag>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              首级集成商类型：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.integratorType || '无' }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              末级集成商：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.finalIntegratorsName || '无' }} <el-tag v-if="info.isFinalIntegratorsServiceSubject" type="danger">
                服务主体
              </el-tag>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              末级集成商类型：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.finalIntegratorsType || '无' }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              计量集成商：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.metrologyIntegratorName || '无' }} <el-tag v-if="info.isMetrologyIntegratorServiceSubject" type="danger">
                服务主体
              </el-tag>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              计量集成商类型：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.metrologyIntegratorType || '无' }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              A类产品服务商：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.productServiceProviderA || '无' }} <el-tag v-if="info.aIsServerSubject" type="danger">
                服务主体
              </el-tag>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              B类产服务商：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.productServiceProviderB || '无' }} <el-tag v-if="info.bIsServerSubject" type="danger">
                服务主体
              </el-tag>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              C类产服务商：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.productServiceProviderC || '无' }} <el-tag v-if="info.cMeaAptitude" type="danger">
                服务主体
              </el-tag>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              服务主体编码：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.serviceSubjectCode }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              服务主体名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.serviceSubjectName }}
            </div>
          </div>
        </div>
        <div v-if="info.manufactureRefurbished" class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              是否官翻机：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.manufactureRefurbished ?'是':'否' }} <el-tag v-if="info.cMeaAptitude" type="danger">
                服务主体
              </el-tag>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              计量计点：
            </div>
            <div class="rj-baseinfo__item">
              {{ $store.getters['enumeration/getmeteringPoint'](info.meteringPoint) }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              细分市场：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.marketSegmentName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              应用场合：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.applicationScenariosName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              应用场景：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.applicationSceneName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              借条单号：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.borrowingOrderNumber }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              CRM客户编码：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.crmAccountCode }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              发货方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.strShipType }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              齐套通知打款邮箱：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.setNoticeMail }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              授权邮箱：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.authorizationEmail }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              使用返利：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.rebateAmount||0 }}元  +  运费{{ info.freightUseRebate||0 }}元
              <el-popover
                v-if="info.rebateAmount || info.freight"
                placement="bottom"
                width="400"
                trigger="click"
                @show="getEditRebateUsedList(info.id)"
              >
                <el-table :data="RebateUsedList" :max-height="400" border>
                  <el-table-column property="rebateNumber" label="返利编码" />
                  <el-table-column property="rebateTypeName" label="返利类型" />
                  <el-table-column property="useAmount" label="使用金额" />
                  <el-table-column property="description" label="备注说明" />
                </el-table>
                <el-button slot="reference" style="margin-left: 10px" type="text">
                  查看
                </el-button>
              </el-popover>
            </div>
          </div>
        </div>

        <div v-if="info.contractType === '销售借用下单'" class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              审批借用天数：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.approveBorrowDays }}
            </div>
          </div>
        </div>
        <!-- <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">区域商务专员意见:</div>
            <div class="rj-baseinfo__item">{{ info.regionBusinessCommissionerOpinion }}</div>
          </div>
        </div> -->
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              收款银行:
            </div>
            <div class="rj-baseinfo__item">
              {{ info.strPaymentBank }}
            </div>
          </div>
        </div>
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              补充条款：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.additionalTerms }}
            </div>
          </div>
        </div>
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              服务条款:
            </div>
            <div class="rj-baseinfo__item">
              {{ info.serviceTerms }}
            </div>
          </div>
        </div>
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              收货回执及到货验收要求:
            </div>
            <div class="rj-baseinfo__item">
              {{ info.receiptArrivalAcceptanceRequirements }}
            </div>
          </div>
        </div>
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              备注说明：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.remarks }}
            </div>
          </div>
        </div>
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              发货备注说明：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.deliverRemark }}
            </div>
          </div>
        </div>
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              开票备注说明：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.invoiceRemark }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              运输方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.shippingType ? '航空' : '陆运' }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              承运商：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.carrier }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              运费：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.freight }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              运费支付方式:
            </div>
            <div class="rj-baseinfo__item">
              {{ info.strFreightPayType }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="es6">
import { getRebateUsedList } from '@/API';
export default {
  props: {
    detailData: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      info: { },
      loading: false,
      RebateUsedList: [],
      tableData: [],
      notTableData: [],
      multipleSelection: []
    };
  },

  watch: {
    detailData: {
      handler (newVal) {
        this.info = newVal;
        newVal.id && this.getEditRebateUsedList(newVal.id);
      },
      deep: true
    }
  },

  methods: {
    getEditRebateUsedList (id) {
      let params = { contractId: id };
      getRebateUsedList(params).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.RebateUsedList = data;
        }
      });
    }
  }

};
</script>
<style lang="scss" scoped>

</style>
